/**
 * ClientPortalDealLocationMap Hook
 *
 * Renders a small Google Map showing the city of the current deal,
 * with a single circle marker at the city center.
 *
 * Style and marker visual match the Survey (SurveyOptionsMap) and
 * Tours (ClientPortalToursMap) maps:
 *   - tile style: window.Enaia.GoogleMapsStyles.DESATURATED_MAP_STYLES
 *   - marker: google.maps.SymbolPath.CIRCLE, #0086e6 fill, white stroke
 *
 * Data attributes:
 *   data-lat       - city latitude (required)
 *   data-lng       - city longitude (required)
 *   data-api-key   - Google Maps API key (required)
 *   data-title     - optional marker title (city name)
 */

const I18n = window.I18n || {}

const MARKER_FILL = "#0086e6"

export const ClientPortalDealLocationMap = {
  async mounted() {
    const lat = parseFloat(this.el.dataset.lat)
    const lng = parseFloat(this.el.dataset.lng)

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return
    }

    try {
      await window.Enaia.loadGoogleMaps()

      const center = { lat, lng }

      const map = new google.maps.Map(this.el, {
        zoom: 11,
        minZoom: 3,
        center,
        backgroundColor: "#e8eef1",
        styles: window.Enaia.GoogleMapsStyles.DESATURATED_MAP_STYLES,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
        gestureHandling: "cooperative",
      })

      new google.maps.Marker({
        position: center,
        map,
        title: this.el.dataset.title || "",
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: MARKER_FILL,
          fillOpacity: 0.9,
          strokeColor: "#ffffff",
          strokeWeight: 2,
        },
      })
    } catch (error) {
      console.error("Error loading deal location map:", error)
      this.el.innerHTML = `<div class="flex items-center justify-center h-full text-[length:0.8125rem] text-gray-500">${I18n["Failed to load map"] || "Failed to load map"}</div>`
    }
  },
}
